export interface IPalette {
    values: { r: number, g: number, b: number, a: number }[]
    setcolor(c: number, r: number, g: number, b: number): void
    setHexColor(c: number, hex: string): void
}

export default class Palette implements IPalette {
    values: { r: number, g: number, b: number, a: number }[] = new Array(14);

    constructor() {
        for (let i = 0; i < this.values.length; i++) {
            this.values[i] = { r: 0, g: 0, b: 0, a: 255 };
        }
    }

    setcolor(c: number, r: number, g: number, b: number): void {
        this.values[c].r = r;
        this.values[c].g = g;
        this.values[c].b = b;
        this.values[c].a = 255;
    }

    setHexColor(c: number, hex: string): void {
        this.values[c].r = parseInt(hex.substring(1,3), 16);
        this.values[c].g = parseInt(hex.substring(3,5), 16);
        this.values[c].b = parseInt(hex.substring(5,7), 16);
        this.values[c].a = 255;
    }
}
